import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { StatePanel } from '@3dspinit/ui';
import { api, type FeedItem } from '../lib/api';
import { ObjectCard } from '../components/ObjectCard';

export function Channel() {
  const { username = '' } = useParams();
  const [name, setName] = useState<string>(`@${username}`);
  const [description, setDescription] = useState<string | null>(null);
  const [assets, setAssets] = useState<FeedItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    void api
      .getChannel(username)
      .then((data) => {
        setName(data.channel?.name ?? `@${username}`);
        setDescription(data.channel?.description ?? data.profile?.bio ?? null);
        setAssets(data.assets);
        setError(null);
      })
      .catch((e) => {
        setError(e instanceof Error ? e.message : 'Channel not found');
        setAssets([]);
      })
      .finally(() => setLoading(false));
  }, [username]);

  return (
    <main className="page">
      <h1 style={{ fontFamily: 'var(--font-display)', marginBottom: '0.25rem' }}>{name}</h1>
      <p className="muted">@{username}</p>
      {description ? <p style={{ maxWidth: '52ch', lineHeight: 1.55 }}>{description}</p> : null}

      {loading && <p className="muted" role="status">Loading channel…</p>}
      {error && <StatePanel variant="error" title="Channel unavailable" message={error} />}

      {!loading && !error && assets.length === 0 && (
        <p className="muted">No published objects on this channel yet.</p>
      )}

      <div className="masonry" style={{ marginTop: '1rem' }}>
        {assets.map((item) => (
          <ObjectCard key={item.id} item={item} />
        ))}
      </div>

      <p style={{ marginTop: '1rem' }}>
        <Link className="btn" to="/">
          Back to Explore
        </Link>
      </p>
    </main>
  );
}
